import { object, string, number, date, InferType } from 'yup';
import * as Yup from 'yup';

const emailPattern = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;

export const formikforgetpass = {
    initialValues: {
        email: ""
    },
    validationSchema: Yup.object({
        email: Yup.string()
            .matches(emailPattern, "Enter a valid email address")
            .required("Required Field")
    })
};